// VA2 - shared Hebrew labels for chatbot-sourced applicant data.
import { formatDate } from '@/custom/helpers/format_date'

const BY_LABELS = { chatbot: 'צ׳אטבוט', bot: 'צ׳אטבוט', system: 'מערכת' }
const SOURCE_LABELS = { chatbot: 'צ׳אטבוט', chat: 'צ׳אטבוט', cv: 'קו"ח', recruiter: 'מגייסת', manual: 'מגייסת' }

export function byLabel (by) {
  if (by === null || by === undefined || by === '') return ''
  return BY_LABELS[String(by).toLowerCase()] || String(by)
}

export function sourceLabel (source) {
  if (!source) return ''
  return SOURCE_LABELS[String(source).toLowerCase()] || String(source)
}

// "2021-03" / "2021-03-01" / ISO -> "03/2021"; a bare year or free text stays as is.
export function monthYear (value) {
  if (value === null || value === undefined || value === '') return ''
  const s = String(value)
  const m = s.match(/^(\d{4})-(\d{2})/)
  return m ? `${m[2]}/${m[1]}` : s
}

export function updatedLine (at, by) {
  const d = formatDate(at)
  if (!d) return ''
  const who = byLabel(by)
  return who ? `עודכן ${d} על ידי ${who}` : `עודכן ${d}`
}
